<section hlmCard aria-labelledby="store-locations-title">
  <div hlmCardHeader>
    <h2 hlmCardTitle id="store-locations-title">Weitere Standorte</h2>
    <p hlmCardDescription>
      Du hast mehrere Läden? Deine Geschäftsadresse ist dein Hauptstandort. Weitere Standorte
      erscheinen zusammen mit ihr auf deiner Shop-Seite und auf der Karte.
    </p>
  </div>

  <div hlmCardContent class="space-y-3">
    @if (actionError()) {
      <div hlmAlert variant="destructive" role="alert">
        <ng-icon name="lucideTriangleAlert" />
        <p hlmAlertTitle>{{ actionError() }}</p>
      </div>
    }

    @if (loading()) {
      <div class="space-y-2" aria-busy="true" aria-label="Standorte werden geladen">
        <hlm-skeleton class="h-16 w-full rounded-lg" />
        <hlm-skeleton class="h-16 w-full rounded-lg" />
      </div>
    } @else if (error()) {
      <div hlmAlert variant="destructive">
        <ng-icon name="lucideTriangleAlert" />
        <p hlmAlertTitle>{{ error() }}</p>
        <div hlmAlertAction>
          <button hlmBtn variant="outline" size="sm" type="button" (click)="load()">
            <ng-icon name="lucideRotateCw" />
            Erneut versuchen
          </button>
        </div>
      </div>
    } @else if (locations().length === 0) {
      <hlm-empty class="border py-8">
        <div hlmEmptyHeader>
          <div hlmEmptyMedia variant="icon"><ng-icon name="lucideStore" /></div>
          <p hlmEmptyTitle>Noch keine weiteren Standorte</p>
          <p hlmEmptyDescription>
            Füge deine anderen Läden hinzu, damit Kunden sehen, wo sie ihren Gutschein einlösen
            können.
          </p>
        </div>
        <div hlmEmptyContent>
          <button hlmBtn size="sm" type="button" (click)="add()">
            <ng-icon name="lucidePlus" />
            Standort hinzufügen
          </button>
        </div>
      </hlm-empty>
    } @else {
      <ul class="space-y-2" aria-label="Weitere Standorte">
        @for (location of locations(); track location.id) {
          <li hlmItem variant="outline">
            <div hlmItemMedia variant="icon">
              @if (location.latitude != null) {
                <ng-icon name="lucideMapPin" />
              } @else {
                <ng-icon
                  name="lucideMapPinOff"
                  hlmTooltip="Noch kein Kartenpunkt: Die Adresse wird gerade gesucht oder wurde nicht gefunden."
                  aria-label="Noch kein Kartenpunkt" />
              }
            </div>
            <div hlmItemContent>
              <p hlmItemTitle>{{ location.name }}</p>
              <p hlmItemDescription>
                {{ location.street }}, {{ location.zip }} {{ location.city }}
                @if (location.country !== 'DE') {
                  · {{ getCountryName(location.country) }}
                }
              </p>
            </div>
            <div hlmItemActions>
              <button
                hlmBtn
                variant="ghost"
                size="icon"
                type="button"
                [attr.aria-label]="location.name + ' bearbeiten'"
                (click)="edit(location)">
                <ng-icon name="lucidePencil" />
              </button>
              <button
                hlmBtn
                variant="ghost"
                size="icon"
                type="button"
                [attr.aria-label]="location.name + ' löschen'"
                [disabled]="deletingId() === location.id"
                (click)="confirmDelete.set(location)">
                @if (deletingId() === location.id) {
                  <hlm-spinner />
                } @else {
                  <ng-icon name="lucideTrash2" />
                }
              </button>
            </div>
          </li>
        }
      </ul>
    }
  </div>

  @if (!loading() && !error() && locations().length > 0) {
    <div hlmCardFooter class="justify-end border-t pt-4">
      <button hlmBtn variant="outline" size="sm" type="button" (click)="add()">
        <ng-icon name="lucidePlus" />
        Standort hinzufügen
      </button>
    </div>
  }
</section>

<app-store-location-dialog
  [open]="dialogOpen()"
  [location]="editing()"
  (saved)="onSaved($event)"
  (close)="dialogOpen.set(false)" />

<hlm-alert-dialog
  [state]="confirmDelete() ? 'open' : 'closed'"
  (stateChanged)="onDeleteDialogState($event)">
  <hlm-alert-dialog-content *hlmAlertDialogPortal class="max-w-lg">
    <div hlmAlertDialogHeader>
      <h3 hlmAlertDialogTitle>„{{ confirmDelete()?.name }}“ löschen?</h3>
      <p hlmAlertDialogDescription>
        Der Standort verschwindet von deiner Shop-Seite. Bereits verkaufte Gutscheine bleiben
        gültig.
      </p>
    </div>
    <div hlmAlertDialogFooter>
      <button hlmAlertDialogCancel hlmBtn variant="outline" (click)="confirmDelete.set(null)">
        Abbrechen
      </button>
      <button hlmAlertDialogAction hlmBtn variant="destructive" (click)="delete()">Löschen</button>
    </div>
  </hlm-alert-dialog-content>
</hlm-alert-dialog>
